import {captureElement} from "../openseadragon/utils/osdCapture";
import {convertSettingsToFilter, notNull} from "../../../utils/utils";
import {notifySuccess} from "./display.notification";
import {FileType, defaultBarcode} from "../../../utils/const";
import {error_manager} from "../../../helper/error_manager";
import {initSlide} from "../../../redux_actions/maps.state.action";
import {store} from "../../../helper/store";
import {post} from "../../../helper/request";
import {
	hideScaleLineForCapture,
	makeWaterMarkHidden,
	makeWaterMarkVisible,
	moveScaleLineToLeft,
	restoreScaleLinePosition,
	restoreScaleLineVisibility,
} from "./map_utils";
import {addCaseFile} from "../../../redux_actions/case.action";

/**
 * @param {string|HTMLElement} elementIdOrEl DOM id or element to capture
 * @param {object} [options]
 * @param {boolean} [options.includeWatermark=true] Morphle logo (normal screenshots)
 * @param {boolean} [options.includeScaleLine=true] OL scale bar (hide for Morpho Chat)
 */
export function takeScreenshot(elementIdOrEl, extension, viewerSettings, handler, barcodeImageSrc, barcodeImgCurrentRotation, options = {}) {
	const includeWatermark = options.includeWatermark !== false;
	const includeScaleLine = options.includeScaleLine !== false;
	if (includeWatermark) {
		makeWaterMarkVisible();
	}
	let scalePrevVisibility = null;
	if (!includeScaleLine) {
		scalePrevVisibility = hideScaleLineForCapture();
	}
	if(notNull(barcodeImageSrc)){
		moveScaleLineToLeft();
	}
	const img = typeof elementIdOrEl === "string"
		? document.getElementById(elementIdOrEl)
		: elementIdOrEl;
	if (!img) {
		if (includeWatermark) makeWaterMarkHidden();
		if (!includeScaleLine) restoreScaleLineVisibility(scalePrevVisibility);
		handler(null);
		return;
	}
	// scale:1 keeps bitmap CSS-sized (matches OpenLayers getSize / calculateExtent).
	const h2cOpts = {};
	if (options.scale != null && Number.isFinite(Number(options.scale))) {
		h2cOpts.scale = Number(options.scale);
	}
	const restoreChrome = () => {
		if (includeWatermark) {
			makeWaterMarkHidden();
		}
		if (!includeScaleLine) {
			restoreScaleLineVisibility(scalePrevVisibility);
		}
		if(notNull(barcodeImageSrc)){
			restoreScaleLinePosition();
		}
	};
	captureElement(img, h2cOpts, {includeScaleLine, shiftScaleLine: notNull(barcodeImageSrc)}).then(canvas => {
		restoreChrome();
		extension = extension.slice(1);
		// TODO: filter needs to be merged for split mode
		let filter = convertSettingsToFilter(viewerSettings);
		let downloadableCanvas = document.createElement('canvas');
		downloadableCanvas.width = canvas.width;
		downloadableCanvas.height = canvas.height;
		let context = downloadableCanvas.getContext('2d');
		downloadableCanvas.setAttribute('crossOrigin', 'anonymous');
		context.filter = filter;
		context.drawImage(canvas, 0, 0, canvas.width, canvas.height);

		if (notNull(barcodeImageSrc)) {
			let barcodeImg = new Image();
			barcodeImg.crossOrigin = "anonymous";
			barcodeImg.src = barcodeImageSrc;

			barcodeImg.onload = () => {
				processBarcodeImage(barcodeImg, barcodeImgCurrentRotation)
			};

			barcodeImg.onerror = (error) => {
				barcodeImg.src = defaultBarcode;
				barcodeImg.onload = () => {
					processBarcodeImage(barcodeImg)
				}
				barcodeImg.onerror = () => {
					downloadableCanvas.toBlob(handler, `image/${extension}`, 0.97);
				}
			};
		} else {
			downloadableCanvas.toBlob(handler, `image/${extension}`, 0.97);
		}

		const processBarcodeImage = (barcodeImg, barcodeImgCurrentRotation = 270) => {
			let targetHeight = downloadableCanvas.height * 0.2;
			let aspectRatio = barcodeImg.width / barcodeImg.height;
			let barcodeImgWidth = targetHeight * aspectRatio;
			let barcodeImgHeight = targetHeight;

			let angle = barcodeImgCurrentRotation;
			let paddingX = 15;
			let paddingY = 15;

			context.save();
			context.translate(downloadableCanvas.width - barcodeImgWidth, downloadableCanvas.height - barcodeImgHeight )
			context.rotate(angle * Math.PI / 180);

			let diffx=0;
			let diffy=0;

			if(angle==90){
				diffx = barcodeImgHeight-barcodeImgWidth - paddingX;
				diffy = -barcodeImgWidth + paddingY;
			}else if(angle==180){
				diffx = -barcodeImgWidth + paddingX;
				diffy = -barcodeImgHeight + paddingY;
			}else if(angle==270){
				diffx = -barcodeImgHeight + paddingX;
				diffy = barcodeImgWidth - barcodeImgHeight - paddingY;
			}else{
				diffx = -paddingX;
				diffy =  -paddingY;
			}

			context.drawImage(barcodeImg, diffx, diffy, barcodeImgWidth, barcodeImgHeight)

			context.restore();
			downloadableCanvas.toBlob(handler, `image/${extension}`, 0.97);
		}
	}).catch(err => {
		restoreChrome();
		error_manager("Screenshot failed", err);
	});
}

export function downloadScreenshot(elementId, name, extension, viewerSettings, barcodeImageSrc, barcodeImgCurrentRotation) {
	takeScreenshot(elementId, extension, viewerSettings, blob => {
		let anchor = document.createElement('a');
		anchor.href = URL.createObjectURL(blob);
		anchor.download = name + extension;
		anchor.style.display = 'none';
		anchor.click();
		anchor.remove();
	}, barcodeImageSrc, barcodeImgCurrentRotation);
}

export const addScreenshotToReport = (elementId, slide, activeMapId, extension, viewerSettings, meta, fileType, onSuccess = () => {}) => {
	takeScreenshot(elementId, extension, viewerSettings, blob => {
		let formData = new FormData();
		formData.append('file', blob, slide.name + extension);
		formData.append('case', slide.case);
		formData.append('slide', slide.id);
		formData.append('meta', meta);
		formData.append('type', fileType || FileType.SCREENSHOT);
		post('/api/files/', formData).then((response) => {
			notifySuccess("case-image", "Screenshot added to report");
			store.dispatch(addCaseFile(response))
			onSuccess()
		}).catch((err) => error_manager("Error adding screenshot to report", err));
	})
}
